module.exports = __webpack_public_path__ + "83fddded0f4d5d7454fe2071c325201a.svg";